import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { getChatList, setChatList } from "../localDb/chat";
import Api from "../service/http";
import { useSocket } from "../service/SocketProvider";
import ChatList from "./chat/ChatList";

const Chats = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [chatLists, setchatLists] = useState([]);

  const { socket, subscribe, unsubscribe } = useSocket();
  const [typingChat, setTypingChat] = useState([]);
  const controlTyping = (chatId, typing) => {
    if (typing) {
      setTypingChat((prevTypingChat) => {
        const ids = prevTypingChat.map((item) => item?.id);
        if (!ids.includes(chatId)) {
          return [
            ...prevTypingChat,
            { id: chatId, time: new Date().getTime() },
          ];
        }
        return prevTypingChat;
      });
    } else {
      setTypingChat((prevTypingChat) =>
        prevTypingChat.filter((item) => item?.id !== chatId)
      );
    }
  };

  setTimeout(() => {
    setTypingChat((prevTypingChat) =>
      prevTypingChat.filter((id) => new Date().getTime() - id?.time < 3000)
    );
  }, 3000);

    useEffect(() => {
    const handleMessage = (data) => {
      switch (data.type) {
        case "WebMeesageTyping":
          if (data.chat_id) {
            controlTyping(data?.chat_id, data.typing);
          }
          break;
        
        case "WebFetchMessage":
          getChatListFromServer();
          break;
        case "WebFetchChat":
          getChatListFromServer();
          break;
        }
      }
      if (socket) subscribe(handleMessage);
    return () => unsubscribe(handleMessage);
  }, [socket, subscribe, unsubscribe]);

  const getChatListFromServer = async () => {
    const response = await Api.get("/web/chats?chat_type=GR");
    if (response.data?.data) {
      setChatList(response.data?.data);
      setchatLists(response.data?.data);
    }
    return response.data?.data || [];
  };

  const syncChatList = async () => {
    const chatList = getChatList();
    setchatLists(chatList);
    if (chatList?.length > 0) {
      navigate(`/chat/${chatList[0]?.id || ""}`);
      getChatListFromServer();
    } else {
      const res = await getChatListFromServer();
      navigate(`/chat/${res[0]?.id}`);
    }
  };

  useEffect(() => {
    syncChatList()
  }, []);

  return (
    <div className="flex-1 h-full overflow-hidden">
      {chatLists?.length > 0 ? (
        <div className="flex h-full w-full">
          <div className={`${id ? "hidden md:flex" : "flex w-full md:w-auto"}`}>
            <ChatList 
              chats={chatLists}
              typingChat={typingChat}
              refresh={syncChatList}
            />
          </div>
          <div className={`flex-1 ${!id ? "hidden md:flex" : "flex"}`}>
            <Outlet />
          </div>
        </div>
      ) : (
        <Loader className="m-auto" />
      )}
    </div>
  );
};

export default Chats;
